import React from 'react'
import './Photos.css'
import ProWa from './images/ProWa.jpg'
import P1j from './images/P1j.jpg'
import Pict from './images/Pict.jpg'
import Pic16 from './images/Pic16.jpg'
import Wh from './images/Wh.jpg'
import Pic1 from './images/Pic1.jpg'
import Pic2 from './images/Pic2.jpg'
import Pic3 from './images/Pic3.jpg'
import Pic4 from './images/Pic4.jpg'
import Pic6 from './images/Pic6.jpg'
import Pic5 from './images/Pic5.jpg'
import Pic7 from './images/Pic7.jpg'
import Pic8 from './images/Pic8.jpg'
import Pic9 from './images/Pic9.jpg'
import Pic10 from './images/Pic10.jpg'
import Pc9 from './images/Pc9.jpg'
import Pic12 from './images/Pic12.jpg'
import Pic14 from './images/Pic14.jpg'
import Pic13 from './images/Pic13.jpg'
import Pic15 from './images/Pic15.jpg'

function Photos() {
    return (
        <div className='photos'>
            <h3>Our Photos</h3>

            <div className="photos__container">
                <div className="photos__containerImage">
                    <img src={Pic1} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={P1j} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pict} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic1} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic2} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic3} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic4} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic5} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic6} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic7} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic8} alt='' />
                </div>
                 <div className="photos__containerImage">
                    <img src={Pic9} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic10} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic12} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic13} alt='' />
                </div>
                 <div className="photos__containerImage">
                    <img src={Pic14} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic15} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pic16} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={ProWa} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Pc9} alt='' />
                </div>
                <div className="photos__containerImage">
                    <img src={Wh} alt='' />
                </div>
            </div>
        </div>
    )
}

export default Photos
